import moment from "moment";
import i18n from "../i18n";
import { boardTypes } from "./moodboardSettings";
import { hashCode } from "../tools";

const today = moment().valueOf();

export default function getBoard(data) {
  let board = {};
  const importBarChart = () => {
    board["errorBars"] = data?.errorBars ?? false;
    board["showValues"] = data?.showValues ?? false;
    board["verticalBars"] = data?.verticalBars ?? false;
    board["pieChart"] = data?.pieChart ?? false;
    board["sortDec"] = data?.sortDec ?? false;
  };

  // set board defaults
  board["id"] = data?.id ?? Math.random(10000000) * 10000000 + "";
  board["type"] = data?.type ?? "";
  board["surveys"] = data?.surveys ?? []; // depricated: old list of filterKey strings
  board["itemIds"] = data?.itemIds ?? [];
  board["labels"] = data?.labels ?? []; // depricated: old list of id strings
  board["labelProps"] = data?.labelProps ?? [];
  board["timeRange"] = data?.timeRange ?? [0, today];
  board["view"] = data?.view ?? "alltime";
  board["update"] = data?.update ?? true;
  board["description"] = data?.description ?? "";
  board["expandDescription"] = data?.expandDescription ?? false;

  // set board specifics
  switch (board.type) {
    case boardTypes.timeline:
      board["timeScale"] = data?.timeScale ?? false;
      board["fullStacked"] = data?.fullStacked ?? false;
      board["connectLine"] = data?.connectLine ?? true;
      board["smoother"] = data?.smoother ?? "time";
      board["size"] = data?.size ?? 12;
      board["title"] = data?.title ?? i18n.t("moodboards.charts.line");
      break;

    case boardTypes.week:
      importBarChart();
      board["size"] = data?.size ?? 6;
      board["title"] = data?.title ?? i18n.t("moodboards.charts.week");
      break;

    case boardTypes.expectedValue:
      importBarChart();
      board["size"] = data?.size ?? 6;
      board["title"] =
        data?.title ?? i18n.t("moodboards.charts.expectedValues");
      board["verticalBars"] = data?.verticalBars ?? true;
      break;

    case boardTypes.quantitative:
      importBarChart();
      board["size"] = data?.size ?? 6;
      board["title"] = data?.title ?? i18n.t("moodboards.charts.means");
      break;

    case boardTypes.frequency:
      importBarChart();
      board["size"] = data?.size ?? 6;
      board["title"] = data?.title ?? i18n.t("moodboards.charts.frequency");
      break;

    case boardTypes.correlation:
      board["size"] = data?.size ?? 6;
      board["title"] = data?.title ?? i18n.t("moodboards.charts.correlation");
      break;

    case boardTypes.wordcloud:
      board["size"] = data?.size ?? 6;
      board["title"] = data?.title ?? i18n.t("moodboards.charts.wordcloud");
      break;

    case boardTypes.clock:
      board["size"] = data?.size ?? 6;
      board["title"] = data?.title ?? "Clock";
      board["clockView"] = data?.clockView ?? "morning";
      break;

    case boardTypes.table:
      board["size"] = data?.size ?? 12;
      board["title"] = data?.title ?? i18n.t("moodboards.charts.table");
      board["hideEmptyRows"] = data?.hideEmptyRows ?? false;
      break;

    case boardTypes.network:
      board["size"] = 12;
      board["title"] = data?.title ?? "Network";
      break;

    case boardTypes.compareTimeRanges:
      board["size"] = data?.size ?? 6;
      board["title"] =
        data?.title ?? i18n.t("moodboards.charts.compareTimeRanges");
      break;

    case boardTypes.occurrence:
      importBarChart();
      board["size"] = data?.size ?? 6;
      board["title"] = data?.title ?? "Number of measurements";
      board["showValues"] = data?.showValues ?? true;

      break;

    default:
      board["size"] = data?.size ?? 6;
      board["title"] = data?.title ?? "Board";
      break;
  }
  return board;
}

export function importBoard(board, rom) {
  // convert old labels to labelProps
  let labelProps = [...board.labelProps];
  const suffixLikert = "$mpc2Slider";
  if (board?.labels?.length > 0 && board.labelProps.length === 0) {
    board.labels.forEach((label) => {
      rom.table.forEach((row) => {
        if (row.labelProps.subType !== "likert") {
          if (label === row.labelProps.label) {
            // convert unique labels
            labelProps.push(row.labelProps);
          } else if (
            label === `${row.labelProps.label} ${row.labelProps.type}` &&
            row.labelProps.index === 0
          ) {
            // convert double label of same type
            labelProps.push(row.labelProps);
          }
        }
      });
      // convert old likert ids to labelProps
      if (label.endsWith(suffixLikert)) {
        const newLabel = label.slice(0, -suffixLikert.length);
        labelProps.push(
          getLabelProps({
            label: `${newLabel}`,
            type: "sliderNegPos",
            subType: "likert",
            index: 0,
          })
        );
      }
    });
  }
  const b = getBoard({ ...board, labelProps, labels: [] });
  return b;
}

export const getLabelProps = ({ label, type, index, subType }) => {
  if (subType) return { label, type, index, subType };
  return { label, type, index };
};

export const getLabelId = (labelProps) => {
  return hashCode(
    `${getLabelProps(labelProps).label} ${getLabelProps(labelProps).type} ${
      getLabelProps(labelProps).index
    }`
  );
};

export const compareLabels = (a, b) =>
  getLabelProps(a).label === getLabelProps(b).label &&
  getLabelProps(a).type === getLabelProps(b).type &&
  getLabelProps(a).index === getLabelProps(b).index;
